import { IncomingMessage } from 'http'

export const isJobsUrl = (req: IncomingMessage) => {
  return req?.url?.includes('-jobs')
}

export const getAutologinRedirectUrl = (req: TODO, autologinToken: string, emailDigest: string) => {
  const tokenEncoded = encodeURIComponent(autologinToken)
  const digestEncoded = encodeURIComponent(emailDigest)
  const tokenPattern = new RegExp(`altkn=(${autologinToken}|${tokenEncoded})`, 'g')
  const digestPattern = new RegExp(`email_digest=(${emailDigest}|${digestEncoded})`, 'g')
  const autologinRedirectUrl = req.url.replace(tokenPattern, '').replace(digestPattern, '')

  if (autologinRedirectUrl.slice(-1) === '?') {
    return autologinRedirectUrl.slice(0, -1)
  }
  return autologinRedirectUrl
}
